// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Profile_avatar__3UGHT","toggle":"Profile_toggle__3i05E"};